<template>
    <span class="tooltip-container">
        <slot />
        <div class="tooltip" :class="[theme, pos]">
            <svg class="tooltip-arrow" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="-0.142151" y="14" width="20" height="20" rx="2" transform="rotate(-45 -0.142151 14)" fill="currentColor"/>
            </svg>
            <slot name="content"/>
        </div>
    </span>
</template>
<script>
export default {
    props: {
        theme: {
            type: String,
            default: 'light'
        },
        position: {
            type: String,
            default: 'right'
        }
    },
    data() {
      return {
          pos: 'right'
      }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
        this.setPosition()
    },
    methods: {
        setPosition() {
            if (window.innerWidth < 560) {
                this.pos = 'bottom'
            } else if (this.position === 'right' && window.innerWidth - this.$el.getBoundingClientRect().right < 330) {
                this.pos = 'left'
            } else if (this.position === 'left' && this.$el.getBoundingClientRect().left < 330) {
                this.pos = 'right'
            } else {
                this.pos = this.position
            }
        },
        handleResize() {
            this.setPosition()
        }
    }
}
</script>
